import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import CO2Service, { Co2ResultsType } from '~/api/services/co2'
import ResultsCo2 from './Steps/ResultsCo2'

interface Props {
  id: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
  farmerId: string
}

const PreviewModal: React.FC<Props> = (props) => {
  const { id, handleClose, uniqueId } = props
  const { t } = useTranslation()

  const [submitPreviewData, setSubmitPreviewData] = useState<Co2ResultsType>(null)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (id) {
      fetchPreviewData()
    }
  }, [id])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await CO2Service.getCO2SubmitData(id)
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(id)}
    isLoading={isBusy}
    closeOnEscape
    style={{ width: '80%', height: '90%' }}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      {!isBusy && <ResultsCo2 results={submitPreviewData} />}
    </>}
    minHeight={'90%'}
    heightContent={'100%'}
    handleClose={() => handleClose()}
  />

}
export default PreviewModal